// Tiny gate: no eager Three.js imports, model requests or WebGL on mobile.
const stage=document.querySelector('.intro-stage');
if(stage){
  stage.dataset.modelState='poster';
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const mobile=matchMedia('(max-width: 700px)');
  const connection=navigator.connection;
  const shouldEnhance=()=>!mobile.matches&&!reduced.matches&&!connection?.saveData&&!/^(slow-2g|2g|3g)$/.test(connection?.effectiveType||'')&&document.visibilityState==='visible';
  let visible=false,scheduled=false,started=false;
  async function enhance(){
    scheduled=false;
    if(started||!visible||!shouldEnhance())return;
    started=true;
    stage.dataset.modelState='loading';
    try{await stage.querySelector('.hero-poster')?.decode();const {start}=await import('./mozi-product-model.js');await start();}
    catch{stage.dataset.modelState='fallback';stage.querySelector('.hero-model')?.remove();}
  }
  function schedule(){
    if(scheduled||started||!visible||!shouldEnhance()||document.readyState!=='complete')return;
    scheduled=true;
    setTimeout(()=>{if('requestIdleCallback'in window)requestIdleCallback(enhance,{timeout:2000});else setTimeout(enhance,0);},1500);
  }
  if('IntersectionObserver'in window){new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();}).observe(stage);}
  else visible=true;
  if(document.readyState==='complete')schedule();else addEventListener('load',schedule,{once:true});
  document.addEventListener('visibilitychange',schedule);
  reduced.addEventListener('change',schedule);
  mobile.addEventListener('change',schedule);
  stage.addEventListener('pointerenter',()=>{if(document.readyState==='complete')schedule();},{once:true});
}
